import React from 'react'
import { connect } from 'react-redux'
import AlertModalView from 'support/popup_dialogs/views/components/alert_modal_view/AlertModalView'
import { hideDialog } from 'support/popup_dialogs/modal_alert_controller/ModalActions'
import { showPopupDialog } from 'support/popup_dialogs'
import i18n from 'support/i18n'
import Navigation from 'support/navigation'
import ErrorModal from './ErrorContainer'
import SuccessModal from './SuccessContainer'
import { postInnovateChallengeRemoveEvaluator } from 'services/innovate/challenge'


const mapStateToProps = () => ({
  title: i18n.t('CONFIRMATION_MESSAGE'),
  // description: 'Are you sure you want to delete the evaluator added to these ideas?     This will remove evaluator from all pending assignments under the selected challenge.',
  description: 'Kindly ensure that all pending evaluators for the challenges ideas are removed.',
  mainButtonText: i18n.t('ACCEPT'),
  cancelable: true,
  cancelButtonText: i18n.t('CANCEL'),
})

const mapDispatchToProps = (dispatch, ownProps) => {
  // console.log("delete props=====>:",ownProps)
  return {
    mainButtonAction: () => {
      const onSuccess = () => {
        showPopupDialog(<SuccessModal description='The Evaluator has been deleted.' />, dispatch)
        // dispatch(getListEvaluatorAssignedForIdea(ideaIdKey))
        // dispatch(getUserValidateEvaluatorScorecardRole(ownProps))
      }
      const onFailure = ({ data }) => {
        const messageTag =
          data && data.error && data.error.error
            ? `BACKEND_ERRORS.${data.error.error}`
            : 'BACKEND_ERRORS.UNEXPECTED'
        showPopupDialog(<ErrorModal description={i18n.t(messageTag)} />, dispatch)
      }
      dispatch(postInnovateChallengeRemoveEvaluator(ownProps.EvaluatorlistParams, onSuccess, onFailure))
      dispatch(hideDialog())
    },
    cancelButtonAction: () => dispatch(hideDialog()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertModalView)